import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const feedback: IMcAppType = {
  name: "feedback_SAP",
  path: "/my-account/feedback/",
  description: "Loads the form stack feedback form for the given formCode",
  parameters: {
    required: ["formCode"],
    properties: {
      context: {
        description: "Additional custom customer context",
        type: "string",
      },
      formCode: {
        description: "ID of the form",
        type: "string",
      },
      title: {
        description: "Title for the ActionBar once the form has loaded",
        type: "string",
        default: "Feedback",
      },
    },
  },
  navFlow: NavFlow.MODAL,
  title: "Feedback",
  parent: Tab.MORE,
  conditions: {
    intent: "feedback",
    customerType: CustomerType.sap,
  },
};

export const feedback_KRAKEN: IMcAppType = {
  ...feedback,
  name: "feedback_KRAKEN",
  path: "/my/feedback/",
  conditions: {
    intent: "feedback",
    customerType: CustomerType.kraken,
  },
};

export const feedback_UNAUTH: IMcAppType = {
  ...feedback,
  name: "feedback_UNAUTH",
  path: "/feedback/",
  conditions: {
    intent: "feedback",
    customerType: CustomerType.unauthenticated,
  },
};
